module.exports = __webpack_public_path__ + "img/hangdao-min.8f543a09.jpg";